import { FetchAPI } from '@renedelangel/helpers';
import { urlServidor } from '../../helpers';

const CAMPOS = `
    seguimientoSiniestroID
    tipoSeguimientoID
    empresaID
    empresa
    usuarioID
    ejercicioID
    semanaAltaID
    estadoID
    estado
    descripcion
    numSiniestro
    bienDaniado
    folio
    montoReclamado
    fechaDanio
    fechaReclamacion
    fechaAlta
    fechaIngreso
    fechaSeguimiento
    numContacto
    responsableID
    personalSeguimiento
    origenTipo
    avance
`;

export const ADD_SEGUIMIENTOSINIESTROS = `
mutation addSeguimientoSiniestros($input: InputAddSeguimientoSiniestros!){
    addSeguimientoSiniestros(input: $input){
        ${CAMPOS}
    }
}
`;

export const UPDATE_SEGUIMIENTOSINIESTROS = `
mutation updateSeguimientoSiniestros($input: InputUpdateSeguimientoSiniestros!){
    updateSeguimientoSiniestros(input: $input){
        ${CAMPOS}
    }
}
`;

export const DELETE_SEGUIMIENTOSINIESTROS = `
mutation deleteSeguimientoSiniestros($input: InputDeleteSeguimientoSiniestros){
    deleteSeguimientoSiniestros(input: $input)
}
`;

export const addSeguimientoSiniestros = async (variables, token) => {
    try {
        let { addSeguimientoSiniestros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: ADD_SEGUIMIENTOSINIESTROS
        });
        return addSeguimientoSiniestros;
    } catch ({ message }) { throw new Error(message); }
};

export const updateSeguimientoSiniestros = async (variables, token) => {
    try {
        let { updateSeguimientoSiniestros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: UPDATE_SEGUIMIENTOSINIESTROS
        });
        return updateSeguimientoSiniestros;
    } catch ({ message }) { throw new Error(message); }
};

export const deleteSeguimientoSiniestros = async (input, token) => {
    try {
        let { deleteSeguimientoSiniestros } = await FetchAPI.graphql({
            token,
            variables: { input },
            url: urlServidor,
            query: DELETE_SEGUIMIENTOSINIESTROS
        });
        return deleteSeguimientoSiniestros;
    } catch ({ message }) { throw new Error(message); }
};
